import { navigate } from "gatsby"
import { useEffect, useState } from "react"

import { questionnaireClient, useQuery } from "@trueskin-web/apis"
import { vwoService } from "@trueskin-web/services"
import { Routes } from "@trueskin-web/translations"

const resetQIdQueryParam = "reset-q-id"

const useQuestionnaireId = () => {
  const [questionnaireId, setQuestionnaireId] = useState(null)

  const { isError: isVerifyError } = useQuery(
    "verifyInitial",
    () => questionnaireClient.verifyInitial({ id: questionnaireId }),
    { cacheTime: 0, enabled: !!questionnaireId }
  )

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const resetQId = searchParams.get(resetQIdQueryParam)

    if (resetQId) {
      vwoService.removeInitialQuestionnaireId()
      setQuestionnaireId(null)
    } else {
      setQuestionnaireId(vwoService.getInitialQuestionnaireId())
    }
  }, [location.search])

  useEffect(() => {
    if (isVerifyError) {
      vwoService.removeInitialQuestionnaireId()
      setQuestionnaireId(null)
      navigate(`${Routes.App.Start.url}`)
    }
  }, [isVerifyError])

  return {
    questionnaireId,
  }
}

export default useQuestionnaireId
